<template>
  <div>
    <v-container fluid>
      <v-card flat class="mx-auto" max-width="960">
        <v-toolbar dense flat color="transparent">
          <v-toolbar-title>{{payload ? payload.marker.number : $t('marker')}} {{payload && payload.marker.label ? ` - ${payload.marker.label}`:''}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu transition="scale-transition" origin="right top" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on">
                  <template>{{$i18n.locale}}</template>
                  <v-spacer></v-spacer>
                  <v-icon>language</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(language, index) in $store.state.languages"
                  :key="index"
                  @click="changeLanguage(language.code)"
                >
                  <v-list-item-icon>{{ fromCodePoint(language.flag) }} {{language.name}}</v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn text @click="loginDialog = true">{{$t('login')}}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card class="mx-auto" outlined>
          <v-layout v-if="payload" wrap>
            <v-flex xs12>
              <v-container grid-list-md text-xs-center>
                <small class="v-label theme--light">
                  <p class="mb-0 text-sm-left">{{$t("date")}}</p>
                </small>
                <p class="text-sm-left">{{payload.marker.date}}</p>
                <small class="v-label theme--light">
                  <p class="mb-0 text-sm-left">{{$t("comments")}}</p>
                </small>
                <p class="text-sm-left">{{payload.marker.comments}}</p>

                <template v-if="payload.marker.installer != null">
                  <small class="v-label theme--light">
                    <p class="mb-0 text-sm-left">{{$t("installer")}}</p>
                  </small>
                  <p class="text-sm-left">{{payload.marker.installer.firstname}} {{payload.marker.installer.name}}</p>
                </template>
                <template v-if="customer">
                  <small class="v-label theme--light">
                    <p class="mb-0 text-sm-left">{{$t("company")}}</p>
                  </small>
                  <p class="text-sm-left">{{customer.Name}}</p>
                  <small class="v-label theme--light">
                    <p class="mb-0 text-sm-left">{{$t("website")}}</p>
                  </small>
                  <p class="text-sm-left">{{customer.Website}}</p>
                </template>
                <div class="border1 mb-2">
                  <transition name="flip" mode="out-in">
                    <solutions key="'s'" :allAttributes="payload.attributes" :marker="payload.marker"></solutions>
                  </transition>
                </div>
                <v-row v-if="!reported">
                  <v-col cols="12" sm="12">
                    <v-btn block color="error" dark @click="dialog = true">{{$t('report')}}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-flex>
          </v-layout>
          <v-container fill-height v-else>
            <loading></loading>
          </v-container>
          <v-card v-if="reports.length > 0" outlined>
            <v-toolbar class="pl-0" dense flat color="transparant">
              <v-subheader>{{$t("report")}}</v-subheader>
            </v-toolbar>
            <v-divider></v-divider>
            <list-transition height="88" class="list v-list--three-line pa-0" tag="v-list">
              <div v-for="(report,i) in reports" :key="i">
                <v-divider></v-divider>
                <v-list-item three-line>
                  <v-list-item-avatar tile size="125" color="grey">
                    <v-img :src="report.image"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle>{{report.name}} {{report.company}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{report.email}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{report.date}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{report.comment}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </list-transition>
          </v-card>
        </v-card>

        <v-dialog v-model="loginDialog" max-width="500px">
          <v-card>
            <v-container>
              <login />
              <a @click="loginDialog = false">{{$t('noLogin')}}</a>
            </v-container>
          </v-card>

          <!-- <v-btn @click="loginDialog = false" color="secondary" block>{{$t('noLogin')}}</v-btn> -->
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-form @submit.prevent="addReport" ref="form" v-model="validForm">
              <v-card-title>
                <span class="headline">{{$t('report')}}</span>
              </v-card-title>
              <v-card-text style="max-height: 500px" class="overflow-auto">
                <v-container>
                  <v-text-field
                    dense
                    outlined
                    v-model="name"
                    :rules="rules($t('name'))"
                    label="Full name"
                  ></v-text-field>

                  <v-text-field
                    dense
                    outlined
                    v-model="company"
                    :rules="rules($t('company'))"
                    label="Company"
                  ></v-text-field>
                  <v-text-field
                    dense
                    outlined
                    v-model="email"
                    :rules="rules(`${$t('email')} / ${$t('phone')}`)"
                    :label="`${$t('email')} / ${$t('phone')}`"
                  ></v-text-field>

                  <v-textarea dense outlined v-model="comment" label="Comment"></v-textarea>

                  <div class="text-center">
                    <image-uploader
                      :preview="false"
                      :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                      capture="environment"
                      :debug="1"
                      :quality="0.8"
                      accept=".jpg, .png"
                      :autoRotate="false"
                      outputFormat="verbose"
                      @input="setImage"
                    >
                      <label for="fileInput" slot="upload-label">
                        <div class="d-flex">
                        <div class="mx-auto text-center">
                          <v-icon v-if="!image" large>add_photo_alternate</v-icon>
                          <template v-else>
                            <v-img :src="image" aspect-ratio="1" contain width="200"></v-img>
                            <a class="primary--text">{{$t('changeImage')}}</a>
                          </template>
                        </div>
                        </div>
                      </label>
                    </image-uploader>
                  </div>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="dialog = false">{{$t('close')}}</v-btn>
                <v-btn
                  color="blue darken-1"
                  type="submit"
                  text
                  :disabled="!image"
                  @click.prevent="addReport"
                >{{$t('send')}}</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </div>
</template>


<script>
import solutions from "@/components/pages/QR/Solutions";
import login from "@/components/Pages/Authentication/Login";
import { serviceihub } from "@/services/service.ihub.js";
const _serviceIhub = new serviceihub();
export default {
  name: "QR",
  components: {
    solutions,
    login
    // zoomMarkup,
  },
  data() {
    return {
      valid: true,
      validForm: false,
      payload: null,
      dialog: false,
      status: "NOK",
      comment: null,
      name: null,
      company: null,
      email: null,
      hasImage: false,
      image: null,
      reported: false,
      loginDialog: false,
      reports: [],
      customer: null
      // blueprint: null
    };
  },
  methods: {
    async getCustomer() {
      try {
        let { data } = await _serviceIhub.getCustomer(this.payload.marker.customerId);
        this.customer = data;
      } catch (error) {
        console.log(err);
      }
    },
    changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
      this.$router.go();
    },
    fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return (
          String.fromCodePoint(codepoint.split(" ")[0]) +
          String.fromCodePoint(codepoint.split(" ")[1])
        );
      }
      return String.fromCodePoint(codepoint);
    },
    setImage: function(output) {
      this.hasImage = true;
      this.image = output.dataUrl;
    },
    rules(property = this.$t("name")) {
      let rules = [
        v => !!v || `${property} ${this.$t("required")}`,
        v => (v && v.length <= 512) || ""
      ];
      return rules;
    },
    addReport() {
      this.$nextTick(() => {
        if (this.$refs.form.validate()) {
          let date = new Date();
          const report = {
            markerId: this.payload.marker.id,
            status: this.status,
            name: this.name,
            company: this.company,
            email: this.email,
            comment: this.comment,
            image: this.image,
            date: date.toJSON()
          };

          this.$http
            .addReport(report)
            .then(res => {
              // this.marker = res.data;
              this.$noty.success('<i class="fas fa-check"></i>');
              this.dialog = false;
              // sessionStorage.setItem("reported", true);
              this.reported = true;
              this.reports.push(report);
            })
            .catch(err => {
              console.log(err);
              this.$noty.error(err);
            });
        }
      });
    }
  },
  mounted() {
    if (sessionStorage.getItem("reported") != null) {
      this.reported = true;
    }
  },
  async created() {
    let lc = localStorage.getItem("language");
    if (lc === null) lc = "EN";
    this.$http
      .getMarkerId(this.$route.params.id, lc)
      .then(res => {
        if (this.$store.state.loggedIn) {
          this.$router.push({
            name: "MarkerDetails",
            params: { id: res.data.marker.id }
          });
        } else {
          this.payload = res.data;
          this.getCustomer();
          this.loginDialog = true;
        }
      })
      .catch(err => {
        this.valid = false;
      });
  }
};
</script>
<style>
#fileInput {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/qr/Index.vue